/**
 * UTM tracking helpers.
 * - captureUtms(): reads utm_source|medium|campaign|term|content + gclid + referrer
 *   from window.location, persists to sessionStorage on first hit, and returns them.
 * - getUtms(): returns whatever is currently stored (or empty).
 */
const KEY = "gd_utms_v1";
const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
    "fbclid",
];

export function captureUtms() {
    if (typeof window === "undefined") return {};
    try {
        const params = new URLSearchParams(window.location.search);
        const hit = {};
        UTM_KEYS.forEach((k) => {
            const v = params.get(k);
            if (v) hit[k] = v;
        });
        // Only persist if we actually captured something.
        if (Object.keys(hit).length > 0) {
            hit.first_page = window.location.pathname + window.location.search;
            hit.referrer = document.referrer || "";
            hit.captured_at = new Date().toISOString();
            sessionStorage.setItem(KEY, JSON.stringify(hit));
            return hit;
        }
    } catch (_) {
        // ignore
    }
    return getUtms();
}

export function getUtms() {
    if (typeof window === "undefined") return {};
    try {
        const raw = sessionStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : {};
    } catch (_) {
        return {};
    }
}
